export enum TipoMedioPago {
    CUENTA_BANCARIA = '1',
}